const cardStyles = {
  marginTop: {
    xs: "3.5rem",
    sm: "4.5rem",
    md: "5.5rem",
    lg: "6rem",
  },
  marginLeft: {
    xs: 1.75,
    sm: 2,
    md: 2.25,
    lg: 2.5,
  },
  marginRight: {
    xs: 1.75,
    sm: 2,
    md: 2.25,
    lg: 2.5,
  },
  paddingLeft: {
    xs: 1.75,
    sm: 2,
    md: 2.25,
    lg: 2.5,
  },
  paddingRight: {
    xs: 1.75,
    sm: 2,
    md: 2.25,
    lg: 2.5,
  },
  width: {
    xs: "80%",
    sm: "85%",
    md: "90%",
    lg: "95%",
  },
  height: {
    xs: "calc(100vh - 9rem)",
    sm: "calc(100vh - 10rem)",
    md: "calc(100vh - 11rem)",
    lg: "calc(100vh - 12rem)",
  },
};

export const CardStyles = cardStyles;

const imageStyles = {
  width: {
    xs: "20rem",
    sm: "22.5rem",
    md: "25rem",
    lg: "27.5rem",
  },
  height: {
    xs: "15rem",
    sm: "20rem",
    md: "25rem",
    lg: "30rem",
  },
  objectFit: "scale",
  float: "left",
  margin: "0 0 0 0",
};

export const ImageStyles = imageStyles;

export const ScreenStyles = {
  minheight: {
    xs: "calc(100vh - 7rem)",
    sm: "calc(100vh - 8rem)",
    md: "calc(100vh - 9rem)",
    lg: "calc(100vh - 10rem)",
  },
  marginTop: {
    xs: "3.5rem",
    sm: "4rem",
    md: "4.5rem",
    lg: "5rem",
  },
  display: "flex",
  flexDirection: "column",
};

export const TextStyles = {
  fontSize: "20px"
}